import Forschungsprojekt from './Forschungsprojekt'
import AbstractPerson from './AbstractPerson'
import Kooperation from './Kooperation'
import Organisationseinheit from './Organisationseinheit'
import OrgaIdent from './OrgaIdent'
import ExterneOrganisation from './ExterneOrganisation'
import Publikation from './Publikation'
import PreisBezeichnung from './PreisBezeichnung'
import Land from './Land'
import Mittelgeber from './Mittelgeber'
import Veranstaltung from './Veranstaltung'
import Parent from './Parent'
import Patent from './Patent'
import Person from './Person'
import PersonIdent from './PersonIdent'
import PersonIdentTyp from './PersonIdentTyp'
import PubIdent from './PubIdent'
import PubIdentTyp from './PubIdentTyp'
import Preis from './Preis'
import AppUser from './AppUser'

export default {
  baseTypes: [
    {
      label: 'Forschungsprojekt',
      schema: Forschungsprojekt
    },
    {
      label: 'Publikation',
      schema: Publikation
    },
    {
      label: 'Veranstaltung',
      schema: Veranstaltung
    },
    {
      label: 'Externe Organisationseinheit',
      schema: ExterneOrganisation
    },
    {
      label: 'Patent',
      schema: Patent
    },
    {
      label: 'Organisationseinheit',
      schema: Organisationseinheit
    },
    {
      label: 'Preis',
      schema: Preis
    },
    {
      label: 'Kooperation',
      schema: Kooperation
    },
    {
      label: 'Interne Person',
      schema: Person
    },
    {
      label: 'Externe Person',
      schema: AbstractPerson
    },
    {
      label: 'Land',
      schema: Land
    },
    {
      label: 'Mittelgeber',
      schema: Mittelgeber
    }
  ],
  // research activities
  forschungsprojekt: Forschungsprojekt,
  kooperation: Kooperation,
  publikation: Publikation,
  parent: Parent,
  patent: Patent,
  veranstaltung: Veranstaltung,
  preis: Preis,
  // UL master data
  abstractperson: AbstractPerson,
  organisationseinheit: Organisationseinheit,
  orgaident: OrgaIdent,
  person: Person,
  personident: PersonIdent,
  personidenttyp: PersonIdentTyp,
  preisbezeichnung: PreisBezeichnung,
  pubident: PubIdent,
  pubidenttyp: PubIdentTyp,
  // external data
  externeorganisation: ExterneOrganisation,
  land: Land,
  mittelgeber: Mittelgeber,
  // administration
  appuser: AppUser
}



// WEBPACK FOOTER //
// ./src/schema/index.js